import Preview from "../../../../content/posts/html-table-generator-code-challenge/Preview";
import * as React from 'react';
export default {
  Preview,
  React
};